var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my"},[_c('navigationBar',{attrs:{"showBack":_vm.showBack}},[_vm._v("我的")]),_c('myInfo'),_c('tabBar',{attrs:{"active":1}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }